import { render, staticRenderFns } from "./TAskContent.vue?vue&type=template&id=2aed2d2d&"
import script from "./TAskContent.vue?vue&type=script&lang=js&"
export * from "./TAskContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports